import { Outlet } from 'react-router';

/**
 * Renders the matched child route with no exit/enter animation.
 * Animated route transitions (AnimatePresence + useOutlet) caused intermittent blank
 * main content when navigating Home / Cases / Drafts.
 */
export function AnimatedOutlet() {
  return (
    <div className="page-transition-shell w-full bg-bg-app">
      <Outlet />
    </div>
  );
}
